export default "__VITE_ASSET__B9_0yEYS__"